import { render, staticRenderFns } from "./TakeQuiz.vue?vue&type=template&id=5f7ffd48&scoped=true&"
import script from "./TakeQuiz.vue?vue&type=script&lang=js&"
export * from "./TakeQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7ffd48",
  null
  
)

export default component.exports